export class TransactionStatus {
    status: string;
    transactionHash?: string;
    connextscanUrl: string;
    transferId?: string;
}
